import React from "react";

import Box from "../Box";
import { SecRayonType } from "../../types/commercial";

import styled from "styled-components";
import { CPopover, CText } from "@carrefour/design-system-components-react";
import useBreakPoint from "../../utils/useBreakPoint";
import BaseDashboardCard from "../BaseDashboardCard";

import { RecurrencesFlop } from "../../types/operational";
import { useTranslation } from "react-i18next";

type TopRecurrencesCardProps = {
  title: string;
  listValue: Array<RecurrencesFlop>;
  services?: SecRayonType;
  isUnavailable: boolean;
  isLoading: boolean;
  openInformationModal: (title?: string) => void;
};

const Text = styled(CText)`
  font-family: system-ui;
`;

const Popover = styled(CPopover)`
  .c-popover__box {
    width: calc(100% + 80px);
  }
  > * .c-popover__header p {
    font-family: system-ui;
    font-size: small;
  }
`;
const TextEllipsis = styled(CText)`
  width: 100%;
  font-family: system-ui;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Table = styled.table`
  width: 100%;
  align-items: center;
  border-collapse: collapse;
`;
const Tr = styled.tr``;
const TrCustom = styled.tr<{ isLast: boolean }>`
  border-collapse: collapse;
  border-bottom: ${(props) => (props?.isLast ? "" : " 1px solid #f0f3f6")};
`;
const Th = styled.th<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
`;
const Td = styled.td<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
  padding-block: 8px;
`;

const TopRecurrencesCard = ({
  listValue,
  title,
  openInformationModal,
}: TopRecurrencesCardProps) => {
  const isBreak = useBreakPoint();
  const {t} = useTranslation();

  return (
    <BaseDashboardCard
      hasModal={true}
      isLoading={false}
      isUnavailable={false}
      title={title}
      openInformationModal={openInformationModal}
      size={"big"}
      importedDateTime={listValue?.[0]?.importedDateTime}
    >
      <Box
        bg={"white"}
        alignItems="center"
        justifyContent={"center"}
        width="100%"
        borderRadius={1}
        pt={1}
      >
        <Table>
          <thead>
            <Tr>
              <Th $textAlign={"left"}>
                <Text bold size={"m"} tagStyle={"p"}>
                  {t('operationnel.libelles_ean')}
                </Text>
              </Th>
              <Th $textAlign={isBreak === "phone" ? "left" : "center"}>
                <Text bold size={"m"} tagStyle={"p"}>
                 {t('operationnel.recurrences')}
                </Text>
              </Th>
            </Tr>
          </thead>
          <tbody>
            {listValue &&
              listValue?.length > 0 &&
              listValue.map((item, index) => {
                return subElements(
                  item,
                  isBreak,
                  listValue?.length === index + 1
                );
              })}
          </tbody>
        </Table>
      </Box>
    </BaseDashboardCard>
  );
};

export default TopRecurrencesCard;

function subElements(item: RecurrencesFlop, isBreak: string, isLast: boolean) {
  return (
    <TrCustom key={"top-rec" + item.eanSAC} isLast={isLast}>
      <Td $textAlign={"left"}>
        <Box width={["170px", "auto"]}>
          {isBreak === "phone" ? (
            <Popover
              title={item.itemDesc}
              position={"top-right"}
              buttonContent={
                <TextEllipsis bold size={"m"}>
                  {item.itemDesc}
                </TextEllipsis>
              }
            />
          ) : (
            <TextEllipsis bold size={"m"}>
              {item.itemDesc}
            </TextEllipsis>
          )}
        </Box>
        <Text size={"m"}>{item.eanSAC}</Text>
      </Td>
      <Td $textAlign={isBreak === "phone" ? "left" : "center"}>
        <Text>
          {item.anomaliesCount
            ? `${new Intl.NumberFormat("fr-FR", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              }).format(item.anomaliesCount)}`
            : "-"}
        </Text>
      </Td>
    </TrCustom>
  );
}
